import { render } from "./BlogFourColumn.vue?vue&type=template&id=6af4f62f"
import script from "./BlogFourColumn.vue?vue&type=script&lang=js"
export * from "./BlogFourColumn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__